import { Link } from 'react-router-dom';

const TradingService = () => {
  return (
    <section 
      className="service section-bg-color open-account-btn-section-nn trading-excellence" 
      aria-label="For Investors"
      style={{ 
        background: "linear-gradient(to top, rgba(248, 249, 250, 0.8) 60%, rgba(255, 255, 255, 0.966) 100%), url('assets/images/new/top-1.png')",
        padding: "110px 0 20px 0"
      }}
    >
      <div className="container">
        <div className="row mt-3">
          <div className="inner-caard">
            
            {/* Algorithmic Trading Card */}
            <div className="col-12 col-md-6">
              <h3 className="mb-3 fw-bold text-gradient text-center">
                Algorithmic Trading<br/> Excellence
              </h3>
              
              <div className="card trading-card">
                <div className="card-content">
                  <div className="image-content">
                    <img 
                      src="assets/images/new/algo-img.png" 
                      alt="Algorithmic Trading Visualization" 
                    />
                  </div>
                  
                  <div className="allggoo-inner-content">
                    <div className="text-content">
                      <div className="section">
                        <p>Automate. Optimize. Outperform - institutional-grade infrastructure for high-frequency and quant strategies.</p>
                        <ul className="checklist">
                          <li data-checked="true">
                            Low latency execution: Direct exchange connectivity and co-location ready.
                          </li>
                          <li data-checked="true">
                            FIX & REST APIs: Full programmatic access: orders, market data, and portfolio.
                          </li>
                          <li data-checked="true">
                            Backtesting & Simulation: Robust sandbox to validate strategies at scale.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  
                  <div className="footer">
                    <Link to="/open-account" >
                      <button className="trk-btn trk-btn--border trk-btn--primary">
                      Open Account
                      </button>
                    </Link>
                    <button
                        className="trk-btn trk-btn--border trk-btn--primary"
                        onClick={() =>
                          window.open(
                            'https://symphonyfintech.com/xts-trading-front-end-api-v2/#tag/Index',
                            '_blank'
                          )
                        }
                      >
                        API Specs
                    </button>

                  </div>
                </div>
              </div>
            </div>
            
            {/* Investors Card */}
            <div className="col-12 col-md-6">
              <h3 className="mb-3 fw-bold text-gradient text-center">
                Smart Investing for <br/>Long-Term Growth
              </h3>
              
              <div className="card trading-card">
                <div className="card-content">
                  <div className="image-content">
                    <img 
                      src="assets/images/new/growth.png" 
                      alt="Investment Performance Chart" 
                    />
                  </div>
                  
                  <div className="allggoo-inner-content">
                    <div className="text-content">
                      <div className="section">
                        <p>Data-driven strategies and personalised wealth management for investors seeking reliable, risk-adjusted returns.</p>
                        <ul className="checklist">
                          <li data-checked="true">
                            Dedicated Advisory: Tailored to your goals and tax profile.
                          </li>
                          <li data-checked="true">
                            Multi-Asset Strategies: Equity, derivatives and alternatives for diversification.
                          </li>
                          <li data-checked="true">
                            White-glove Support: Personal relationship manager for UHNI & family office clients.                          
                          </li>
                         
                        </ul>
                      </div>
                    </div>
                  </div>
                  
                  <div className="footer">
                    <Link to="/open-account" >
                      <button className="trk-btn trk-btn--border trk-btn--primary">
                      Open Account
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default TradingService;